// extracted by mini-css-extract-plugin
export default {"container":"upload-form_container__CJBT4","input":"upload-form_input__2R0mm","label":"upload-form_label__vUurA","icon":"upload-form_icon__Dr9Fn","cover":"upload-form_cover__ypl3H"};